import { render, staticRenderFns } from "./CreatedMindbodyProfile.vue?vue&type=template&id=21729b81&scoped=true&"
import script from "./CreatedMindbodyProfile.vue?vue&type=script&lang=js&"
export * from "./CreatedMindbodyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CreatedMindbodyProfile.vue?vue&type=style&index=0&id=21729b81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21729b81",
  null
  
)

export default component.exports